import type { BranchEntity } from '@/features/branch/domain/entities/BranchEntity'
import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { OrderRateReasonEntity } from '@/features/orderRateReason/domain/entities/OrderRateReasonEntity'
import type { RegionEntity } from '@/features/region/domain/entities/RegionEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'

export class OrderRateFilterEntity {
  orderId?: string
  user?: UserMiniEntity
  page?: number
  limit?: number
  date?: string[]
  driver?: DriverEntity
  branch?: BranchEntity
  region?: RegionEntity
  userOrderRateReason?: OrderRateReasonEntity
  referenceCode?: string
  driverCommentSearch?: string
  branchCommentSearch?: string
  onlyCommentsReturned?: boolean
}
